const routes = {
  DASHBOARD: "/",
  PROFILE: "/profile",
  FAQ: "/faq",
  TOTURIAL: "/toturial",
  ANNOUNCEMENTS: "/announcements",
  POLICY: "/policy",
  INSURANCEPOLICY: "/insurance-policy",
  CONSULTATION: "/consultation-request",
  COMMISSION: "/commission",
  INSTALLMENT: "/installment",
  UNDERCONSTRUCTION: "/under-construction",
  PREPAYMENT: "/pre-payment",
  SERVERERROR: "/server-error",
  INSURANCERATE: "/insurance-rate",
  INQUERY: "/inquery",
  ISSUING: "/issuing",
  PROFILENOTFOUND:"/profile-not-found",
  OFFERSLIST:"/insurance-universal-offers",
  OFFERSDETAILS:"/insurance-universal-offers/:id",
  PREVIEW:"/preview",
  UNITLINK: "/unitlink",
  UNITLINKISSUING: "/unitlink-issuing",
  UNIVERALISSUING:"/universal-issuing",
  INQUERYUPDATE:  "/inquery-update/:id",
  UNITLINKUPDATE: "/unitlink-update/:id",
  UNITLINKISSUINGUPDATE: "/unitlink-issuing/:id",
  ISSUINGUPDATE: "/issuing/:id",
  PROJECTS: "/projects",
  UNIVERSAL: "/universal/:id",
  UNIVERALUPDATE: "/universal-update/:id",
  UNIVERALISSUINGUPDATE:"/universal-issuing/:id",
  TRANSACTIONS: "/transactions",
  AGENTSIGNUP:"/agent-sign-up",
  AGENTEDIT:"/agent-edit"



};

export default routes;
